import { Notification, MessageBox } from 'element-ui';
import { ElNotificationOptions } from 'element-ui/types/notification';
import { ElMessageBoxOptions } from 'element-ui/types/message-box';
import { MessageType } from 'element-ui/types/message';
import { RESTRICTIVE_SANITIZER_OPTIONS, sanitize } from '@/main/utils/html-sanitizer';


enum ApiMessageTypes { SUCCESS = 'success', INFO = 'info', WARNING = 'warning', ERROR = 'error' }

export interface MessageBoxInfo {
	message: string, title?: string, options?: ElMessageBoxOptions
}

export interface ApiNotificationOption {
	Message: string,
	Title: string,
	Type: number,
}

export function showNotification(message: ElNotificationOptions) {
	Notification(message);
}
export enum MessageTypeStatus {
	SUCCESS = 1,
	INFO = 2,
	WARNING = 3,
	ERROR = 4,
	OTHER = 5,
}

export function getMessageType(val: number): MessageType | undefined {
	switch (val) {
		case MessageTypeStatus.SUCCESS:
			return ApiMessageTypes.SUCCESS;
		case MessageTypeStatus.INFO:
			return ApiMessageTypes.INFO;
		case MessageTypeStatus.WARNING:
			return ApiMessageTypes.WARNING;
		case MessageTypeStatus.ERROR:
			return ApiMessageTypes.ERROR;
		case MessageTypeStatus.OTHER:
			return undefined;
		default:
			return ApiMessageTypes.INFO;
	}
}

export async function showAlert(info: MessageBoxInfo): Promise<void> {
	const message = sanitize(info.message, RESTRICTIVE_SANITIZER_OPTIONS);

	await (info.title
		? MessageBox.alert(message, info.title, info.options)
		: MessageBox.alert(message, info.options));
}


export async function showConfirm(info: MessageBoxInfo): Promise<boolean> {
	const message = sanitize(info.message, RESTRICTIVE_SANITIZER_OPTIONS);

	try {
		await (info.title
			? MessageBox.confirm(message, info.title, info.options)
			: MessageBox.confirm(message, info.options));

		return true;
	} catch {
		return false;
	}
}
